import { render, staticRenderFns } from "./ProcessStatisticsDialog.vue?vue&type=template&id=7b4b8190&"
import script from "./ProcessStatisticsDialog.vue?vue&type=script&lang=js&"
export * from "./ProcessStatisticsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports